export const AWAITING_KNOCK_APPROVAL = 'AWAITING_KNOCK_APPROVAL';
export const PRESENTER_SETTINGS_MODAL = 'PRESENTER_SETTINGS_MODAL';
export const UPDATE_SETTINGS_MODAL = 'UPDATE_SETTINGS_MODAL';
export const GENERIC_UPDATE_SETTINGS_MODAL = 'GENERIC_UPDATE_SETTINGS_MODAL';
export const REQUEST_PERMISSIONS_MODAL = 'REQUEST_PERMISSIONS_MODAL';
export const SCREENSHARE_MODAL = 'SCREENSHARE_MODAL';
export const READINESS_CHECK_MODAL = 'READINESS_CHECK_MODAL';
export const LOST_REALTIME_SOCKET_CONNECTION =
  'LOST_REALTIME_SOCKET_CONNECTION';
export const INVALID_JOIN_REQUEST = 'INVALID_JOIN_REQUEST';
